import { createFeature, createReducer, on } from '@ngrx/store';
import {
  DocumentUploadStatus,
  PreEnrollmentDocument,
} from '../models/pre-enrollment-documents.model';
import { PreEnrollmentDocumentsActions } from './pre-enrollment-documents.actions';

export interface PreEnrollmentDocumentsState {
  studyPlanName: string;
  documents: PreEnrollmentDocument[];
  loading: boolean;
  error: string;
}

const initialState: PreEnrollmentDocumentsState = {
  studyPlanName: '',
  documents: [],
  loading: false,
  error: '',
};

export const preEnrollmentDocumentsFeature = createFeature({
  name: 'preEnrollmentDocuments',
  reducer: createReducer(
    initialState,
    on(PreEnrollmentDocumentsActions.loadPageData, (state) => ({
      ...state,
      loading: true,
      error: '',
    })),
    on(
      PreEnrollmentDocumentsActions.loadPageDataSuccess,
      (state, { studyPlanName, documents }) => ({
        ...state,
        studyPlanName,
        documents,
        loading: false,
        error: '',
      }),
    ),
    on(PreEnrollmentDocumentsActions.loadPageDataFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),
    on(PreEnrollmentDocumentsActions.uploadDocument, (state, { document, file }) => ({
      ...state,
      error: '',
      documents: state.documents.map((item) =>
        item.id === document.id
          ? {
              ...item,
              status: DocumentUploadStatus.Uploading,
              fileName: file.name,
              rejectionReason: '',
            }
          : item,
      ),
    })),
    on(PreEnrollmentDocumentsActions.uploadDocumentFailure, (state, { document, error }) => ({
      ...state,
      error,
      documents: state.documents.map((item) => (item.id === document.id ? document : item)),
    })),
    on(PreEnrollmentDocumentsActions.refreshDocumentsSuccess, (state, { documents }) => ({
      ...state,
      documents,
      error: '',
    })),
    on(PreEnrollmentDocumentsActions.refreshDocumentsFailure, (state, { error }) => ({
      ...state,
      error,
      documents: state.documents.filter(
        (document) => document.status !== DocumentUploadStatus.Uploading,
      ),
    })),
  ),
});
